/*
  Newsletter-Seite (sections/tronso-newsletter.liquid): Anmeldung ohne Neuladen.

  Das Formular geht per fetch an /contact. Shopify antwortet mit der fertig
  gerenderten Seite; daraus wird der neue Inhalt dieses Formulars übernommen
  (Dankessatz oder Fehlermeldung). Überschrift, Text, Feld und Kleingedrucktes
  blenden aus, der Dankessatz an derselben Stelle ein, der Kicker bleibt stehen.

  Rückfall auf das normale Abschicken mit Neuladen, wenn Shopify eine
  Captcha-Abfrage dazwischenschiebt oder etwas schiefgeht. Ohne JavaScript
  funktioniert die Seite ohnehin wie bisher.
*/
(() => {
  const LEAVE_MS = 200;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  function fallback(form) {
    form.dataset.tronsoNative = 'true';
    form.submit();
  }

  async function handleSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-tronso-newsletter]')) return;
    if (form.dataset.tronsoNative === 'true' || form.dataset.tronsoBusy === 'true') return;

    event.preventDefault();
    form.dataset.tronsoBusy = 'true';
    const button = form.querySelector('button[type="submit"]');
    if (button) button.setAttribute('aria-disabled', 'true');

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
      });

      // Captcha oder unerwartete Antwort: normal abschicken, Shopify übernimmt.
      if (!response.ok || /\/challenge/.test(response.url)) {
        fallback(form);
        return;
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = form.id ? doc.getElementById(form.id) : null;
      if (!next) {
        fallback(form);
        return;
      }

      if (!reducedMotion.matches) {
        form.classList.add('is-leaving');
        await wait(LEAVE_MS);
      }

      form.innerHTML = next.innerHTML;
      form.classList.remove('is-leaving');
      if (!reducedMotion.matches) {
        form.classList.add('is-entering');
        form.addEventListener('animationend', () => form.classList.remove('is-entering'), { once: true });
      }

      const target =
        form.querySelector('[role="status"]') || form.querySelector('[aria-invalid="true"]');
      if (target) {
        target.focus({ preventScroll: true });
        // Wurde die Seite kürzer, liegt der Satz eventuell über dem Fenster.
        if (target.getBoundingClientRect().top < 0) {
          target.scrollIntoView({ block: 'center', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        }
      }
    } catch (error) {
      fallback(form);
      return;
    } finally {
      delete form.dataset.tronsoBusy;
      if (button && button.isConnected) button.removeAttribute('aria-disabled');
    }
  }

  document.addEventListener('submit', handleSubmit);
})();
